/**
 * Authentication Service
 * 
 * Handles authentication-related operations like logout.
 * Includes FCM token cleanup for push notification unregistration.
 */

import api from "./api";
import * as notificationService from "./notificationService";

// Key used to store FCM token in localStorage
const FCM_TOKEN_KEY = 'fcmToken';

/**
 * Handle user logout
 * 
 * Clears all authentication tokens and user data.
 * Also unregisters the device from FCM to stop receiving notifications.
 * 
 * Flow:
 * 1. Unregister FCM token from backend (if exists)
 * 2. Clear all localStorage items
 * 3. Clear auth header from axios
 * 4. Redirect to login page
 */
export const handleLogout = async () => {
  try {
    // Get stored FCM token
    const fcmToken = localStorage.getItem(FCM_TOKEN_KEY);
    
    // Unregister FCM token from backend if it exists
    // This prevents notifications from being sent to this device after logout
    if (fcmToken) {
      try {
        await notificationService.unregisterDevice(fcmToken);
        console.log('[Auth] FCM token unregistered successfully');
      } catch (error) {
        // Log but don't block logout if FCM unregistration fails
        console.error('[Auth] Failed to unregister FCM token:', error);
      }
    }
  } catch (error) {
    console.error('[Auth] Error during logout cleanup:', error);
  } finally {
    // Always clear local data, even if FCM unregistration fails
    
    // Clear authentication tokens
    localStorage.removeItem('authToken');
    localStorage.removeItem("refreshToken");
    localStorage.removeItem('partnerType');
    
    // Clear FCM token
    localStorage.removeItem(FCM_TOKEN_KEY);
    
    // Clear axios auth header
    delete api.defaults.headers.common["Authorization"];
    
    // Clear cart and order data
    localStorage.removeItem('selectedQuantities');
    localStorage.removeItem('totalPrice');
    localStorage.removeItem('cartItems');
    
    // Redirect to login page
    window.location.href = '/login';
  }
};
  